"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggedInServiceNotice = exports.AnonymousServiceNotices = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const constants_1 = require("src/hello_assets/src/constants");
require("./serviceNotice.less");
const ProductLink = ({ href, children }) => React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer" }, children);
const ServiceClosureAnnouncement = () => React.createElement(React.Fragment, null,
    React.createElement("strong", { className: "serviceClosureAnnouncementTitle" }, "\uD83D\uDEA8 Important announcement \uD83D\uDEA8"),
    React.createElement("div", { className: "serviceClosureAnnouncementBody" },
        React.createElement("p", null,
            React.createElement(ProductLink, { href: constants_1.URL_USERGEEK }, "userGeek"),
            ", ",
            React.createElement(ProductLink, { href: constants_1.URL_CONFIGEEK }, "configeek"),
            ", ",
            React.createElement(ProductLink, { href: constants_1.URL_CANISTERGEEK }, "canisterGeek"),
            ", ",
            React.createElement(ProductLink, { href: constants_1.URL_NFTGEEK }, "nftGeek"),
            ", ",
            React.createElement(ProductLink, { href: constants_1.URL_VPGEEK }, "vpGeek"),
            ", and ",
            React.createElement(ProductLink, { href: constants_1.URL_SNSGEEK }, "snsGeek"),
            " \u2014 along with their APIs",
            React.createElement("br", null),
            "will be permanently shut down on ",
            React.createElement("strong", null, "December 31, 2026"),
            "."),
        React.createElement("p", null,
            "We\u2019re retiring these services to focus our efforts on ",
            React.createElement(ProductLink, { href: constants_1.URL_GEEKFACTORY }, "GeekFactory Hub"),
            " and ",
            React.createElement(ProductLink, { href: constants_1.URL_IDGEEK }, "idGeek 2.0"),
            "."),
        React.createElement("p", null, "Thanks to everyone who\u2019s been part of these projects over the years."),
        React.createElement("p", null, "The GeekFactory Team")));
const ServiceClosureBanner = () => React.createElement("div", { className: "serviceClosureBanner", role: "status" },
    React.createElement("div", { className: "serviceClosureBannerContent" },
        React.createElement(ServiceClosureAnnouncement, null)));
const AnonymousServiceNotices = () => React.createElement("section", { className: "anonymousServiceClosure", "aria-label": "Service closure announcement" },
    React.createElement(ServiceClosureBanner, null));
exports.AnonymousServiceNotices = AnonymousServiceNotices;
const LoggedInServiceNotice = () => React.createElement(antd_1.Row, { className: "loggedInServiceClosureRow" },
    React.createElement(antd_1.Col, { span: 1 }),
    React.createElement(antd_1.Col, { span: 22 },
        React.createElement(ServiceClosureBanner, null)),
    React.createElement(antd_1.Col, { span: 1 }));
exports.LoggedInServiceNotice = LoggedInServiceNotice;
